<template>
  <div class="account-setting">
    <div class="account-setting__panel">
      <p class="text-muted account-setting__page-desc mb-1">
        Manage your account security. Use a strong password you do not reuse elsewhere.
      </p>

      <b-card body-class="p-1 p-md-2">
        <div class="account-setting__section-header d-flex align-items-start mb-1">
          <div class="account-setting__section-icon rounded d-flex align-items-center justify-content-center flex-shrink-0">
            <feather-icon icon="LockIcon" size="18" />
          </div>
          <div>
            <h5 class="account-setting__section-title mb-25">
              Change password
            </h5>
            <p class="text-muted small mb-0">
              Update the password for
              <strong v-if="userEmail">{{ userEmail }}</strong>
              <span v-else>your account</span>.
            </p>
          </div>
        </div>

        <account-setting-password :user-email="userEmail" />
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AccountSettingPassword from './AccountSettingPassword.vue'

function readUserEmail() {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    return (userData && userData.email) || ''
  } catch (e) {
    return ''
  }
}

export default {
  name: 'AccountSetting',
  components: {
    BCard,
    AccountSettingPassword,
  },
  data() {
    return {
      userEmail: readUserEmail(),
    }
  },
}
</script>

<style scoped>
/* Navbar already shows pageTitle — reclaim content-wrapper gap */
.account-setting {
  margin-top: -0.85rem;
}
.account-setting__panel {
  max-width: 42rem; /* ~672px — centered, not lonely left card */
  margin-left: auto;
  margin-right: auto;
}
.account-setting__page-desc {
  font-size: 0.875rem;
  line-height: 1.45;
}
.account-setting__section-icon {
  width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.75rem;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}
.account-setting__section-title {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
}
</style>
